<template>
  <b-modal :active="isComponentEditActive" has-modal-card :can-cancel="false">
    <form class="modal-card profile-edit" @submit.prevent="editUser">
      <b-loading :is-full-page="false" :active="isLoading"></b-loading>
      <header class="modal-card-head">
        <div>
          <p class="modal-card-title">Editar perfil</p>
          <p class="profile-edit-subtitle">Actualiza tus datos personales.</p>
        </div>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field label="Nombre">
              <b-input v-model.trim="user.name" type="text" autocomplete="given-name" required expanded></b-input>
            </b-field>
          </div>
          <div class="column is-6-tablet">
            <b-field label="Apellido paterno">
              <b-input v-model.trim="user.pather_lastname" type="text" autocomplete="family-name" required expanded></b-input>
            </b-field>
          </div>
          <div class="column is-6-tablet">
            <b-field label="Apellido materno">
              <b-input v-model.trim="user.mother_lastname" type="text" required expanded></b-input>
            </b-field>
          </div>
          <div class="column is-6-tablet">
            <div class="field">
              <label for="profile-rut" class="label">RUT</label>
              <div class="control">
                <input id="profile-rut" class="input" type="text" :value="formattedRut" @input="onRutInput" maxlength="12" autocomplete="off" autocapitalize="characters" spellcheck="false" required />
              </div>
            </div>
          </div>
          <div class="column is-6-tablet">
            <b-field label="Correo electrónico">
              <b-input v-model.trim="user.email" type="email" autocomplete="email" required expanded></b-input>
            </b-field>
          </div>
        </div>
        <b-message v-if="error" type="is-danger" role="alert">{{ error }}</b-message>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" :disabled="isLoading" @click="closeEdit()">Cancelar</button>
        <button class="button is-primary" type="submit" :disabled="isLoading">{{ isLoading ? 'Guardando...' : 'Guardar cambios' }}</button>
      </footer>
    </form>
  </b-modal>
</template>

<script>
import { formatRut, normalizeRut } from "../utils/rut";

export default {
  props: ["isComponentEditActive", "closeEdit", "user_id", "nameUserConnect"],
  data() {
    return {
      user: { name: "", pather_lastname: "", mother_lastname: "", rut: "", email: "", password: "" },
      isLoading: true,
      error: "",
    };
  },
  computed: {
    formattedRut() {
      return formatRut(this.user.rut);
    },
  },
  created() {
    this.chargeUserData();
  },
  methods: {
    onRutInput(event) {
      const input = event.target;
      const charactersBeforeCaret = normalizeRut(input.value.slice(0, input.selectionStart)).length;
      this.user.rut = normalizeRut(input.value);
      this.$nextTick(() => {
        input.value = this.formattedRut;
        let caret = 0;
        let characters = 0;
        while (caret < input.value.length && characters < charactersBeforeCaret) {
          if (/[0-9K]/.test(input.value.charAt(caret))) characters++;
          caret++;
        }
        input.setSelectionRange(caret, caret);
      });
    },
    editUser() {
      if (localStorage.getItem('perfil') === 'functionary') return;
      if (this.isLoading) return;
      this.error = "";
      this.isLoading = true;
      const data = { ...this.user, rut: normalizeRut(this.user.rut) };
      this.$http.put(`api/${localStorage.getItem('perfil')}/user/` + this.user_id, data).then(
        response => {
          window.localStorage.setItem("user", JSON.stringify(response.body.user));
          window.localStorage.setItem("userName", `${response.body.user.name} ${response.body.user.pather_lastname} ${response.body.user.mother_lastname}`);
          this.nameUserConnect();
          this.isLoading = false;
          this.closeEdit();
          this.toast("Perfil actualizado correctamente", "is-success");
        },
        () => {
          this.error = "No se pudieron guardar los cambios. Inténtalo nuevamente.";
          this.isLoading = false;
        }
      );
    },
    chargeUserData() {
      this.$http.get(`api/${localStorage.getItem('perfil')}/user/` + this.user_id).then(
        response => {
          this.user = response.body.user;
          this.isLoading = false;
        },
        () => {
          this.error = "No se pudieron cargar tus datos. Cierra esta ventana e inténtalo nuevamente.";
          this.isLoading = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.profile-edit { width: min(94vw, 620px); border-radius: 14px; overflow: hidden; }
.profile-edit .modal-card-head { background: #f5faf8; }
.profile-edit .modal-card-title { color: #24464b; font-weight: 700; }
.profile-edit-subtitle { margin-top: .3rem; color: #657d7d; font-size: .88rem; }
.profile-edit .columns { margin-top: -.5rem; }
.profile-edit .column { padding-bottom: .25rem; }
.profile-edit .modal-card-foot { justify-content: flex-end; gap: .5rem; background: white; }
.profile-edit .button { border-radius: 8px; }
@media (max-width: 560px) {
  .profile-edit .modal-card-foot { flex-direction: column-reverse; align-items: stretch; }
}
</style>
